import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import type { AlnRow } from '../types/importData'

function companyEditLink(id: unknown, label: unknown): ReactNode {
  const s = id != null && id !== '' ? String(id) : ''
  const text = label != null && label !== '' ? String(label) : '—'
  if (!s || s === '0') return <span className="text-slate-700">{text}</span>
  return (
    <Link to={`/company/edit/${s}`} className="text-button underline" target="_blank" rel="noreferrer">
      {text}
    </Link>
  )
}

export function NonLinkText({ children }: { children: ReactNode }) {
  return <span className="text-slate-700">{children}</span>
}

export function CompanyChangeCell({ row, side }: { row: AlnRow; side: 'previous' | 'current' }) {
  const id = side === 'previous' ? row.previous_company_id : row.current_company_id
  const name = side === 'previous' ? row.previous_mgmt : row.current_mgmt
  const listed = side === 'previous' ? row.previous_mgmt_listed : row.current_mgmt_listed
  const invite = side === 'previous' ? row.previous_mgmt_pmc_invite : row.current_mgmt_pmc_invite

  const main = companyEditLink(id, name)
  const hasName = name != null && String(name).trim() !== ''
  const listedPart = listed === '1' || listed === 1 ? ' - Active' : ' - Not Active'
  const invitePart =
    invite === '1' || invite === 1 ? ' - Invite Required' : ' - Invite Not Required'

  return (
    <span className="text-slate-700">
      {main}
      {hasName && (
        <span className="text-slate-600">
          {listedPart}
          {invitePart}
        </span>
      )}
    </span>
  )
}
